import {useEffect} from 'react';

import {useApiHooks} from '../../api-hook/api-hook';
import {UseHookType} from '../../api-hook/api-hook-type';
import {ReviewsAnalysisRadarQueryType} from '../review-radar/review-radar-type';

import {fetchReviewRateCompetitors} from './review-rate-api';
import {ReviewRateCompetitorsResponseType} from './review-rate-type';

export function useReviewRateCompetitors(
    options: ReviewsAnalysisRadarQueryType,
    mainFilterKey: string
): UseHookType<ReviewRateCompetitorsResponseType> {
    const {isInProgress, setIsInProgress, processError, setProcessError, result, setResult, reset} =
        useApiHooks<ReviewRateCompetitorsResponseType>();

    useEffect(() => {
        setIsInProgress(true);

        fetchReviewRateCompetitors(options, mainFilterKey)
            .then(setResult)
            .finally(() => setIsInProgress(false))
            .catch(setProcessError);
    }, [setIsInProgress, setProcessError, setResult, options, mainFilterKey]);

    return {isInProgress, processError, result, reset};
}
